import monetateService from "~/services/monetate.service";
import {isCategory, getMatchingCategory} from "~/utils/recommendation"

const SAFE_ROUTES = {
  trolley: "/trolley",
  orderConfirmation: "/order-confirmation",
  myAccount: "/account/home",
  categories: "/categories",
  search: "/search",
};

const PAGE_TYPE_MAPPING = {
  "/": "main",
  "/branches": "branches",
  "/brands": "brands",
  "/content/aboutus": "about",
  "/login": "login",
  "/checkout": "checkout",
  "/account/saved-lists": "savelist",
  "/register": "register",
  "/contact": "contact",
  "/content/pro": "procard",
  "/deals": "deals",
  "/new-launch": "newlaunch",
  "/content/faq": "faq",
  "/guarantee": "guarantee",
  "/content/delivery": "delivery",
  "/content/payment": "payment",
  "/content/clickandcollect": "clickandcollect",
  "/content/returnsandexchanges": "returnandexchanges",
} as const;

// @todo change this to generic middleware for tracking 
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.client) {
   let pageType = "other";
/*
    if (to.meta.layout === "product") {
        new monetateService().productDetailViewEvent(to.params.id);

        const { useAlgoliaEvent } = await import('~/composables/useAlgoliaEvent');
        const algoliaEventHandler = useAlgoliaEvent();
        algoliaEventHandler.sendProductViewEvent(to.params.id); // TODO: need to send objectIDs from search

        pageType = "product";
        if(import.meta.client){
          window.monetateQ = window.monetateQ || [];
          window.monetateQ.push([
            "addProductDetails", [{
              productId: to.params.id,
              sku: to.params.id
            }]
          ]);
          window.monetateQ.push(["trackEvent", ["viewProduct"]]);
        }
    }
*/ 
    if (to.path in PAGE_TYPE_MAPPING) {
      pageType = PAGE_TYPE_MAPPING[to.path as keyof typeof PAGE_TYPE_MAPPING];
    }

    if (to.path === "/") {
      // @TODO: implement and complete `trackHomePageView`
      pageType = "main";
    }

    if(to.path.includes(SAFE_ROUTES.categories)){
      pageType = "taxonomy" 
    }
    if(isCategory(to.path)){
      let category = getMatchingCategory(to.path);
      if(category){
          new monetateService().trackCatrgoryDetailView(category);
          pageType = "taxonomy";
      }
    }


    if (to.path.includes(SAFE_ROUTES.trolley)) {
        new monetateService().trackTrolleyPageView();
        pageType = "cart"
        
    }
    if(to.path.includes(SAFE_ROUTES.myAccount)){
        new monetateService().trackMyAccountView();
        pageType = "account"
    }
    if(to.path.includes(SAFE_ROUTES.search)){
        new monetateService().trackSearchPageView();
        pageType = "search"
    }
    const match = to.path.match(/^\/([\w-]{1,30})\/([\w-]{1,30})\/c(\d{1,10})$/);
    if (match) {
      new monetateService().trackPLpView();
      pageType = "taxonomy";
    }
    // Set the page type in Monetate
    if(import.meta.client){
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(["setPageType", pageType]);
    window.monetateQ.push([
      "trackData"
    ]);

  }
  }
});



